import { useMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";

const HORIZONTAL_LAYOUT_RATIO = "40/60" as const;

export const useResponsiveHorizontalFormLayout = () => {
  const isMdScreen = useMdScreenMediaQuery();

  return {
    layout: isMdScreen ? ("horizontal" as const) : ("vertical" as const),
    horizontalLayoutInputProps: isMdScreen
      ? { horizontalLayoutRatio: HORIZONTAL_LAYOUT_RATIO }
      : {},
  } as const;
};
